import { ReduxAction } from '../../ReduxStorage/actions';
import { ActionTypes } from './actions';
import { INITIAL_STATE } from './state';
import { ApplicationState, TosUpdatedDatesStatus } from './types';

export const Application = (
  state: ApplicationState = INITIAL_STATE,
  action: ReduxAction
): ApplicationState => {
  switch (action.type) {
    case ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_START:
      return {
        ...state,
        tosUpdatedDates: {
          status: TosUpdatedDatesStatus.Loading,
          dates: null,
        },
      };
    case ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_SUCCEED:
      return {
        ...state,
        tosUpdatedDates: {
          status: TosUpdatedDatesStatus.Loaded,
          dates: action.dates,
        },
      };
    case ActionTypes.APPLICATION_TOS_UPDATE_DATE_LOAD_FAILED:
      return {
        ...state,
        tosUpdatedDates: {
          status: TosUpdatedDatesStatus.Error,
          dates: null,
        },
      };
    case ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_START: {
      return {
        ...state,
        tosNextUpdateDates: {
          status: TosUpdatedDatesStatus.Loading,
          dates: null,
        },
      };
    }
    case ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_SUCCEED: {
      return {
        ...state,
        tosNextUpdateDates: {
          status: TosUpdatedDatesStatus.Loaded,
          dates: action.dates,
        },
      };
    }
    case ActionTypes.APPLICATION_TOS_NEXT_UPDATE_LOAD_FAILED: {
      return {
        ...state,
        tosNextUpdateDates: {
          status: TosUpdatedDatesStatus.Error,
          dates: null,
        },
      };
    }
    default: {
      return state;
    }
  }
};
